import CryptoJS from 'crypto-js';

const SECRET_KEY = 'mis';

// URL-safe Base64 encode
const base64UrlEncode = (str) =>
  str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

// URL-safe Base64 decode
const base64UrlDecode = (str) =>
  str.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - (str.length % 4)) % 4);

export const encrypt = (text) => {
  try {
    if (typeof text !== 'string') {
      if (text === undefined || text === null) {
        throw new Error('Encrypt input is null or undefined');
      }
      text = JSON.stringify(text); // convert object or number to string
    }

    const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
    return base64UrlEncode(encrypted); // URL-safe encoded string
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

export const encrypt_short = (text) => {
  try {
    if (typeof text !== 'string') {
      if (text === undefined || text === null) {
        throw new Error('Encrypt input is null or undefined');
      }
      text = JSON.stringify(text);
    }

    let result = '';
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      result += String.fromCharCode(charCode);
    }

    let encoded = base64UrlEncode(btoa(result));
    
    // Ensure minimum 5 characters by padding if necessary
    if (encoded.length < 5) {
      encoded = encoded.padEnd(5, '0');
    }
    
    // Ensure maximum 8 characters by slicing
    return encoded.substring(0, 8);
  } catch (error) {
    console.error('Short encryption error:', error);
    return null;
  }
};

export const decrypt = (cipherText) => {
  try {
    if (cipherText.length >= 5 && cipherText.length <= 8) {
      const cleanCipher = cipherText.replace(/0+$/, ''); // remove padding added during short encrypt
      const decodedB64 = atob(base64UrlDecode(cleanCipher));
      let decrypted = '';
      for (let i = 0; i < decodedB64.length; i++) {
        const charCode = decodedB64.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
        decrypted += String.fromCharCode(charCode);
      }
      if (decrypted) return decrypted;
    }

    const base64 = base64UrlDecode(cipherText);
    let bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
    let decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) {
      const ciphertextWA = CryptoJS.enc.Base64.parse(base64);
      const decryptedWA = CryptoJS.AES.decrypt(
        { ciphertext: ciphertextWA },
        SECRET_KEY
      );
      decrypted = decryptedWA.toString(CryptoJS.enc.Utf8);
    }

    if (!decrypted) throw new Error('Invalid decryption or empty result');

    return decrypted;
  } catch (error) {
    alert('Decryption failed: ' + error.message);
    console.error('Decryption error:', error);
    return null;
  }
};